<template>
  <div>
    <drawer :app="app" />

    <v-container class="mt-1">
      <v-card raised>
        
        <v-card-title v-if="id!=null">          
          <div  v-text="$t('labels.AddCoApplicant')" />
          <v-spacer />   
        </v-card-title>

        <div style="margin: 1px 5px 5px 15px;">
          <div class="px-3" v-if="id != null">
            <v-row>
             
              <v-col cols="12" md="6" v-if="id.PrimaryFlag == false">
                  <p_dd menu="ApplicantGroupType" :label="$t('labels.ApplicantType')" v-model="id.ApplicantGroupTypeDD" />
              </v-col>
              
            </v-row>
            <v-row>
              <v-col cols="12" md="3">
                <p_dd menu="Salutation" v-model="id.SalutationDD" :label="$t('labels.Salutation')" />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field   v-model="id.FirstName">
                  <template slot="label"><span v-html="$t('labels.FirstName')" /></template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field   v-model="id.LastName">
                  <template slot="label"><span v-html="$t('labels.LastName')" /></template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <comdatey :label="$t('labels.DOB')" :min="date120Years" :max="date18Years" v-model="id.DOB" />
              </v-col>
              <v-col cols="12" md="6">
                <!-- <v-text-field v-model="id.Email"> -->
                   <!-- <template slot="label"><span v-html="$t('labels.Email')" /></template> -->
                   <com_Email :label="$t('labels.MaritalStatus')" v-model="id.Email" />
                <!-- </v-text-field> -->
              </v-col>

            
              <v-col cols="12" md="3">
                <!-- <v-text-field :label="$t('labels.HomePhoneNumber')" v-model="id.HomePhone" v-mask="'(###) ###-####'"/> -->
                  <com_phone @DisableSave="HomeDisableSave" v-model="id.HomePhone" :label="$t('labels.HomePhoneNumber')" :masked="false" />
              </v-col>
                <v-col cols="12" md="3">
                <!-- <v-text-field :label="$t('labels.MobilePhoneNumber')" v-model="id.Mobile" v-mask="'(###) ###-####'"/> -->
                  <com_phone @DisableSave="MobileDisableSave" v-model="id.Mobile" :label="$t('labels.MobilePhoneNumber')" :masked="true" />
              </v-col>

              <v-col  v-if="this.app.ReqSin == 1 && this.app.showSin == true" cols="12" md="3">
                <v-text-field :rules="[rules.validate]"  v-model="id.SIN" v-mask="'### ### ###'">
                  <template slot="label"><span v-html="$t('labels.SINR')" /></template>
                </v-text-field>
              </v-col>
              <v-col v-else-if="this.app.ReqSin == 2 && this.app.showSin == true" cols="12" md="3">
                  <v-text-field :rules="[rules.validate]"  v-model="id.SIN" v-mask="'### ### ###'">
                  <template slot="label"><span v-html="$t('labels.SIN')" /></template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <p_dd :label="$t('labels.MaritalStatus')" menu="MaritalStatus" v-model="id.MaritalStatusDD" />
              </v-col>
 
                <v-col cols="12" md="6" v-if="id.PrimaryFlag == false">
                  <p_dd menu="Relationship" :label="$t('labels.RelationshipToPrimaryApplicant')"
                   v-model="id.RelationshipDD" />
                </v-col>
              
            
            </v-row>
          </div>

          <v-card-actions class="mb-5 mt-10">
            <v-spacer />
            <v-btn :disabled="this.MobileDisableSaveFlag == true || this.HomeDisableSaveFlag == true" @click="next" color="primary float-right">{{ $t("labels.Next") }}</v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-container>

    <div class="loading" v-if="loadFlag">Loading&#8230;</div>
  </div>
</template>

<script>
import drawer from "@/pages/app/agent/user/app/drawer";
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import model from "@/shared/dataModels/app";
import p_dd from "@/shared/components/ddSelect";
import comdatey from "@/shared/components/datePickerY";
import com_Email from "@/shared/components/email";
import com_phone from "@/shared/components/phone";
export default {
  components: { comdatey, drawer, p_dd,com_Email,com_phone },
  data() {
    return {
      rules: {
        validate: (value) => {
          if (value != "") {
            var val = value.replace(/\s/g, "");
            return this.checklength(val);
          } else {
            return true;
          }
        },
      },
      MobileDisableSaveFlag: false,
      HomeDisableSaveFlag: false,
      showSwitchToPrimaryFlag: true,
      loadFlag: false,
      app: model.appModel(),
      a:null,
      id:null,      
      
      applicantID: this.$route.params.applicantid,
      mortgageApplicationID: this.$route.params.appid,
      siteID: this.$route.params.siteid,
      userID: null,
      drawerFlag: false
    };
  },
  computed: {
    date18Years() {
      let n = new Date();
      n.setFullYear(n.getFullYear() - 17);
      return n.toISOString().substr(0, 10);
    },
    date120Years() {
      let n = new Date();
      n.setFullYear(n.getFullYear() - 120);
      return n.toISOString().substr(0, 10);
    }
    
  },
  methods: {
     HomeDisableSave(data){
      this.HomeDisableSaveFlag = data;
    },
     MobileDisableSave(data){
      this.MobileDisableSaveFlag = data;
    },
    checklength: function (val) {
      var sin = val.replace(/\s/g, "");
      return this.validatesin(sin) || "Invalid SIN";
    },
    validatesin(sin) {
      var check, even, tot;
      if (sin.length != 9) {
        return "Invalid SIN";
      }
      if (typeof sin === "number") {
        sin = sin.toString();
      }

      if (sin.length === 9) {
        // convert to an array & pop off the check digit
        sin = sin.split("");
        check = +sin.pop();

        even = sin
          // take the digits at the even indices
          .filter(function (_, i) {
            return i % 2;
          })
          // multiply them by two
          .map(function (n) {
            return n * 2;
          })
          // and split them into individual digits
          .join("")
          .split("");

        tot = sin
          // take the digits at the odd indices
          .filter(function (_, i) {
            return !(i % 2);
          })
          // concatenate them with the transformed numbers above
          .concat(even)
          // it's currently an array of strings; we want numbers
          .map(function (n) {
            return +n;
          })
          // and take the sum
          .reduce(function (acc, cur) {
            return acc + cur;
          });

        // compare the result against the check digit
        return check === (10 - (tot % 10)) % 10;
      } else throw "Invalid SIN";
    },
    next() {      
      if(!this.valid()) return;
      let postData={
        SiteID : this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        ApplicantID: this.applicantID,
        Identification: this.id
      }
      this.loadFlag=true;
      dataSvc.getHttp().post('/api/MTGAPPAddCoApplicant',postData).then(res=>{
        this.loadFlag = false;
        if(res.data.ReturnStatus.ReturnCode==200){
          if(res.data.NextStep==2)
            this.$router.push('/' + this.siteID + '/user/' + this.mortgageApplicationID + '/applicant/' + res.data.ApplicantID + '/address' );
          else 
            this.$router.push('/' + this.siteID + '/user/' + this.mortgageApplicationID + '/applicant/' + res.data.ApplicantID + '/income' );
        }
      });      
    },
    valid(){      

      if( this.id.ApplicantGroupTypeDD < 0){
        this.$alert(this.$t('labels.Warning'), this.$t('errors.IdentificationMissingApplicantGroupType'));
        return false;
      }
      if(!this.id.FirstName){
        this.$alert(this.$t('labels.Warning'), this.$t('errors.IdentificationMissingFirstName'));
        return false;
      }
      if(!this.id.LastName){
        this.$alert(this.$t('labels.Warning'), this.$t('errors.IdentificationMissingLastName'));
        return false;
      }
     
      if(!this.id.DOB){
        this.$alert(this.$t('labels.Warning'), this.$t('errors.IdentificationMissingDOB'));
        return false;
      }  
       if(!this.id.Email){
        this.$alert(this.$t('labels.Warning'), this.$t('errors.RequiredEmailAddress'));
        return false;
      }   
       if(!this.id.HomePhone && !this.id.Mobile){
         this.$alert(this.$t('labels.Warning'), this.$t('errors.IdentificationMissingPhone'));
          return false;
      }
          if (this.app.ReqSin == 1 && !this.id.SIN && this.app.showSin == true) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("errors.IdentificationSIN")
        );
        return false;
      }
      if (this.id.SIN) {
        var sin = this.id.SIN.replace(/\s/g, "");
        var res = this.validatesin(sin) || "Invalid SIN";
        if (res == "Invalid SIN") {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.InvalidSin"));
          return false;
        }
      }
      
       if(this.id.MaritalStatusDD==null){
         this.$alert(this.$t('labels.Warning'), this.$t('errors.IdentificationMissingMaritalStatus'));
        return false;
      }
       
      if(this.id.RelationshipDD<0){
        this.$alert(this.$t('labels.Warning'), this.$t('errors.IdentificationMissingRelationship'));
        return false;
      }

   
      return true;
    },
    loadPage() {
      if (this.appID != 0) {
        this.loadFlag = true;
        let postData = {
          SiteID: this.siteID,
          UserID: this.userID,
          MortgageApplicationID: this.mortgageApplicationID
        };
        dataSvc
          .getHttp()
          .post("/api/MTGAPPLoad", postData)
          .then(res => {
            this.loadFlag = false;
            if (res.data.ReturnStatus.ReturnCode == 200) {
              this.app = res.data;
              
              this.a = model.applicantModel();
              this.id = this.a.Identification;

              this.showSwitchToPrimaryFlag =  !this.id.PrimaryFlag;
              setTimeout(() => {}, 200);
            }
            this.app.UserID = this.userID;
            this.app.SiteID = this.siteID;
          });
      } else {
        this.app.UserID = this.userID;
        this.app.SiteID = this.siteID;
      }
    }
  },
  created() {
    this.userID = localStorageSvc.getUser();
    if (this.userID != "") {
      this.loadPage();
    } else {
      this.$router.push("/" + this.siteID);
    }
  },
  mounted() {}
};
</script>

<style></style>
